import { useTranslation } from 'next-i18next';
import { FC } from 'react';
import ListingBadge from 'src/common/components/ListingBadge';
import { usePreviewModeContext } from 'src/common/providers/PreviewModeProvider';

import styles from './Badges.module.scss';

type Props = {
  isSuperowner?: boolean;
  /**
    * Represents the year (like `2023`) the owner was awarded best of,
    * and is used to determine if the `best_of` badge should be rendered.
   */
  bestOfYear?: string;
};

const Badges: FC<Props> = ({ isSuperowner, bestOfYear }) => {
  const [t] = useTranslation(['common', 'admin-listing-preview']);
  const { previewMode } = usePreviewModeContext();

  if (!previewMode && !isSuperowner && !bestOfYear) {
    return null;
  }
  const currentYear = new Date().getFullYear();

  return (
    <div className={styles.root}>
      {(previewMode || isSuperowner) && (
        <ListingBadge
          variant="superowner"
          previewMode={previewMode}
        >
          {t('listing-card--listing-badge--superowner')}
        </ListingBadge>
      )}
      {(previewMode || bestOfYear) && (
        <ListingBadge
          variant="bestOfYear"
          previewMode={previewMode}
        >
          {t('listing-card--listing-badge--best-of-year', { year: bestOfYear || currentYear })}
        </ListingBadge>
      )}
    </div>
  );
};

export default Badges;
